import React from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import PropTypes from 'prop-types';

const HotelTabSection = ({ node }) => {
  const tab = node.attrs.tab || 'rooms';
  return (
    <NodeViewWrapper
      as="div"
      className="hotel-tabs-section"
      data-tab={tab}
      data-active={tab === 'rooms' ? 'true' : 'false'}
    >
      <NodeViewContent />
    </NodeViewWrapper>
  );
};

HotelTabSection.propTypes = {
  node: PropTypes.shape({
    attrs: PropTypes.shape({
      tab: PropTypes.oneOf(['rooms', 'about', 'photos']),
    }),
  }).isRequired,
};

export default HotelTabSection;
